import jQuery from "jquery";
import { tns } from "tiny-slider/src/tiny-slider.js";
window.$ = window.jQuery = jQuery;
window.tns = tns; // Disponibilizar Tiny Slider globalmente

let cards = $(".flavors-carousel");
if (cards.length > 0) {
    let slider = tns({
        container: ".flavors-carousel",
        items: 1,
        gutter: 20,
        slideBy: 1,
        controls: true,
        nav: false,
        loop: true,
        mouseDrag: true,
        autoplay: false,
    });
}
